import { flatten, partition, pipe, propEq } from 'ramda'

export const getReplyValue = reply => {
  if (!reply) {
    return ''
  }
  return reply?.value
}

export const getComplexReplyValue = (reply, path) => {
  return `${reply.value[path]}`
}

export const findReplyByQuestionId = (replies, questionId) => {
  return replies.find(reply => reply.question.id === questionId)
}

export const mountAssetsValues = replies => {
  const saida = {}
  replies.forEach(reply => {
    if (!saida[reply.blockIndex]) {
      saida[reply.blockIndex] = {}
    }
    const indexData = saida[reply.blockIndex]
    if (reply?.question?.type?.name === 'asset') {
      indexData.id = reply.value.id
      indexData[reply.question.name] = reply.value.name
    } else {
      indexData[reply.question.name] = reply.value
      indexData[reply.question.id] = reply.value
    }
  })
  return Object.values(saida)
}

export const getAssetIds = serviceOrder => {
  let assetsIds = []
  const isManualComparison = getReplyValue(findReplyByQuestionId(serviceOrder.replies, 599))

  const mainDevice = findReplyByQuestionId(serviceOrder.replies, 598)

  if (mainDevice) {
    assetsIds = assetsIds.concat([mainDevice.value.id])
  }

  if (isManualComparison) {
    const secondDevice = findReplyByQuestionId(serviceOrder.replies, 600)
    if (secondDevice) {
      assetsIds = assetsIds.concat([secondDevice.value.id])
    }

    return assetsIds
  } else {
    return
  }
}

export const filterSameTypeDevices = (mainDeviceType, allDevices) => {
  return allDevices.filter(device => {
    const deviceType = device.placeLevelsResume.find(level => level.levelId === 31).name.toLowerCase()

    return deviceType === mainDeviceType
  })
}

export const sameTypeDevices = (mainDevice, secondaryDevice) => {
  const mainDeviceType = mainDevice.placeLevelsResume.find(level => level.levelId === 31).name.toLowerCase()
  const secondaryDeviceType = secondaryDevice.placeLevelsResume.find(level => level.levelId === 31).name.toLowerCase()

  return mainDeviceType === secondaryDeviceType
}

export const getFieldValue = (field, fieldValues) => {
  const fieldValueFound = fieldValues.find(fv => fv.field.name === field)
  if (!fieldValueFound) return '-'

  return fieldValueFound.value
}

export const getDeviceFields = deviceType => {
  const smartphone = [
    'Nome',
    'Fabricante',
    'Tela',
    'Sistema Operacional',
    'SIM Card compatível',
    'Processador',
    'Memória interna',
    'Memória RAM',
    'Bateria',
    'Câmeras (traseira / frontal)',
    'Dual SIM',
    'Bluetooth',
    'Wi-Fi',
    'Hotspot Wi-Fi',
    'NFC',
    'GPS',
    'Slot para cartão de memória',
    'Memória expansível',
    'Fingerprint',
    'Reconhecimento facial',
    'Rede móvel',
    'Resolução da tela'
  ]

  const tablet = [
    'Nome',
    'Fabricante',
    'Tela',
    'Sistema Operacional',
    'SIM Card compatível',
    'Processador',
    'Memória interna',
    'Memória RAM',
    'Bateria',
    'Câmeras (traseira / frontal)',
    'Dual SIM',
    'Bluetooth',
    'Wi-Fi',
    'Hotspot Wi-Fi',
    'NFC',
    'GPS',
    'Slot para cartão de memória',
    'Memória expansível',
    'Fingerprint',
    'Reconhecimento facial',
    'Rede móvel'
  ]

  const modem = [
    'Nome',
    'Fabricante',
    'SIM Card compatível',
    'Hotspot Wi-Fi',
    'Utilização',
    'Conexão com telefones fixos',
    'Conexão com cabo de dados',
    'Portas',
    'Compatível com atenas',
    'Agenda',
    'SMS',
    'Slot para cartão de memória',
    'Viva-Voz integrado',
    'Identificador de chamadas',
    'Alarme',
    'Calculadora',
    'Compatibilidade',
    'Rede móvel'
  ]

  const devices = {
    smartphone,
    tablet,
    'box/modem': modem
  }

  return devices[deviceType]
}

export const mainDeviceAsFirst = pipe(partition(propEq('isMainDevice', true)), flatten)
